import { Button } from "@/components/buttons/Button";
import { onOpenCreateNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import PlusIcon from "@/common/images/icons/plus.svg?react";
import { memo } from "react";
import "./AddNicheBtn.scss";

export const AddNicheBtn = memo(() => {
  return (
    <Button onClick={onOpenCreateNichePopup} round size="m" className="addNicheBtn"><PlusIcon /></Button>
  );
});
